import React from 'react';
import { Navigate, Outlet } from 'react-router';

import {
  useActiveWorkspaceContext,
  PermissionKey,
} from '@/true-fsd/data/advertiser-account';

export type PermissionGuardProps = {
  permissionKey: PermissionKey;

  children?: React.ReactNode;
};

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permissionKey,
  children,
}) => {
  const context = useActiveWorkspaceContext();
  const hasPermission = context.permission[permissionKey];
  if (!hasPermission) {
    return <Navigate to={'/'} replace />;
  }

  // return children
  return children ? children : <Outlet context={context} />;
};
